<template>
    <div class="warning-list">
        <mc-operate-bar>
            <template slot="left">
                <div class="mc-search-bar">
                    <div class="mc-search-bar-input">
                        <el-date-picker style="width:200px;margin-right:10px;" v-model="searchParmas.startTime" type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss" placeholder="起始时间">
                        </el-date-picker>
                        <el-date-picker style="width:200px;margin-right:10px;" v-model="searchParmas.endTime" type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss" placeholder="结束时间">
                        </el-date-picker>
                        <el-input style="width:200px;margin-right:10px;" placeholder="输入告警站点" v-model="searchParmas.site"></el-input>
                        <el-select style="width:200px;margin-right:10px;" v-model="searchParmas.status" placeholder="告警状态">
                            <el-option v-for="(item,index) in statusOption" :key="index" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <el-button class="mc-search-bar-btn" type="primary" icon="el-icon-search" size="mini" @click="$_getTableList()"></el-button>
                    <el-button class="mc-search-bar-btn" type="danger" icon="el-icon-close" @click="$_reset()" size="mini"
                        v-if="searchParmas.site||searchParmas.startTime||searchParmas.endTime||searchParmas.status"></el-button>
                </div>
            </template>
        </mc-operate-bar>
        <mc-table ref="mc-table" :table-option="tableOption" v-loading="tableOption.loading">
            <template slot="table-components">
                <el-table-column :prop="tableOption.head[0].prop" :label="tableOption.head[0].label" :width="tableOption.head[0].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        {{$_handleTime(scope.row.occure_at)}}
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[1].prop" :label="tableOption.head[1].label" :width="tableOption.head[1].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span class="deal-item" @click="dialog.siteName.methods.open(scope.row)">{{scope.row.site_name}}</span>
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[2].prop" :label="tableOption.head[2].label" :width="tableOption.head[2].width"
                    v-if="tableOption.head.length>0"></el-table-column>
                <el-table-column :prop="tableOption.head[3].prop" :label="tableOption.head[3].label" :width="tableOption.head[3].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span v-if="scope.row.severity == 0"></span>
                        <span v-else-if="scope.row.status == 1">正常</span>
                        <span v-else-if="scope.row.status == 2">一般</span>
                        <span v-else-if="scope.row.status == 3">紧急</span>
                        <span v-else-if="scope.row.status == 4">严重</span>
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[4].prop" :label="tableOption.head[4].label" :width="tableOption.head[4].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 0"></span>
                        <span v-else-if="scope.row.status == 1">已消除</span>
                        <span v-else-if="scope.row.status == 2">待处理</span>
                        <!-- <span v-else-if="scope.row.status == 3">紧急</span>
                        <span v-else-if="scope.row.status == 4">严重</span> -->
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[5].prop" :label="tableOption.head[5].label" :width="tableOption.head[5].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span @click="dialog.warning.methods.open(scope.row)" class="deal-item content">{{scope.row.content}}</span>
                    </template>
                </el-table-column>
            </template>
        </mc-table>
        <mc-pager :pager-option.sync="pager" ref="warning-list-pager" @getList="$_getTableList"></mc-pager>

        <mc-dialog :dialog-option.sync="dialog.siteName">
            <template slot="content">
                <mc-layout-row label-text="站点名称" :labelWidth="120">
                    <mc-label info>{{site.site_name}}</mc-label>
                </mc-layout-row>
                <mc-layout-row label-text="省" :labelWidth="120">
                    <mc-label info>{{site.province}}</mc-label>
                </mc-layout-row>
                <mc-layout-row label-text="市" :labelWidth="120">
                    <mc-label info>{{site.city}}</mc-label>
                </mc-layout-row>
                <mc-layout-row label-text="地址" :labelWidth="120">
                    <mc-label info>{{site.address}}</mc-label>
                </mc-layout-row>
            </template>
        </mc-dialog>

        <mc-dialog :dialog-option.sync="dialog.warning">
            <template slot="content">
                <mc-label info>{{this.dialog.warning.data.content}}</mc-label>
            </template>
        </mc-dialog>
    </div>
</template>

<script>
    export default {
        name: "warning-list",
        data() {
            return {
                searchParmas: {
                    startTime: '',
                    endTime: '',
                    site: '',
                    status: ''
                },
                site: [],
                statusList: [],
                statusOption: [],
                pager: {
                    page: 1,
                    per_page: 10,
                    per_pages: [10, 20, 30, 40, 50],
                    total: 0,
                },
                tableOption: {
                    loading: false,
                    index: {
                        disable: true,
                    },
                    operations: {
                        disable: false,
                        label: "操作",
                        items: [{
                            label: "查看",
                            type: "default",
                            size: 'mini',
                            click: (index, row) => {
                                this.$_goToDetails(row);
                            },
                        }, ],
                    },
                    head: [{
                            prop: "occure_at",
                            label: "告警时间",
                            width: "150",
                        },
                        {
                            prop: "site_name",
                            label: "告警站点",
                            width: "",
                        },
                        {
                            prop: "host",
                            label: "告警对象",
                            width: "300",
                        },
                        {
                            prop: "severity",
                            label: "告警级别",
                            width: "100",
                        },
                        {
                            prop: "status",
                            label: "告警状态",
                            width: "100",
                        },
                        {
                            prop: "content",
                            label: "告警内容",
                            width: ""
                        },
                    ],
                    data: [],
                },
                dialog: {
                    siteName: {
                        visible: false,
                        title: "站点详情",
                        style: {
                            showConfirm: false,
                            showCancel: false,
                        },
                        methods: {
                            open: (row) => {
                                this.dialog.siteName.data.id = row.site_id;
                                this.$_getSite(row.site_id);
                                this.dialog.siteName.visible = true;
                            },
                        },
                        data: {
                            id: "",
                        },
                    },
                    warning: {
                        visible: false,
                        title: "告警内容",
                        style: {
                            showConfirm: false,
                            showCancel: false,
                        },
                        methods: {
                            open: (item) => {
                                this.dialog.warning.visible = true;
                                this.dialog.warning.data.content = item.content;
                            },
                        },
                        data: {
                            content: "",
                        },
                    }
                },
            }
        },
        mounted() {
            this.$_getTableList();
            this.$_getStatusList();
        },
        methods: {
            $_getTableList: async function () {
                this.tableOption.loading = true;
                let params = {
                    page: this.pager.page,
                    per_page: this.pager.per_page,
                    starttime: this.$_reduceTime(this.searchParmas.startTime),
                    endtime: this.$_reduceTime(this.searchParmas.endTime),
                    sitename: this.searchParmas.site,
                    status: this.searchParmas.status,
                }
                let data = await this.$api.userWarningList.getList.getWarningList.call(this, params);
                if (data !== false) {
                    this.pager.total = data.total;
                    this.tableOption.data = data.items;
                }
                this.tableOption.loading = false;
            },
            $_getStatusList: async function () {
                let params = {};
                let data = await this.$api.userWarningList.getList.getStatusList.call(this, params);
                if (data !== false) {
                    this.statusList = data;
                    for (let i = 0; i < this.statusList.length; i++) {
                        this.statusOption[i] = {
                            value: this.statusList[i].status_id,
                            label: this.statusList[i].status_name
                        }
                    }
                }
            },
            $_reset() {
                this.searchParmas.startTime = '';
                this.searchParmas.endTime = '';
                this.searchParmas.site = '';
                this.searchParmas.status = '';
                this.$_getTableList()
            },
            $_getSite: async function () {
                let params = {
                    site_id: this.dialog.siteName.data.id
                }
                let data = await this.$api.userPendWarning.getList.getSite.call(this, params);
                if (data !== false) {
                    this.site = data[0];
                }
            },
            $_handleTime(time) {
                let time1 = time.replace('T', " ");
                let origindate = Date.parse(time1);
                let date = new Date(origindate + 8 * 60 * 60 * 1000)
                let Y = date.getFullYear() + '-';
                let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                let D = date.getDate() + ' ';
                let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
                let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
                return Y + M + D + h + m + s
                // return date;
            },
            $_reduceTime(time) {
                if(!time){
                    return
                }
                let time1 = time.replace('T', " ");
                let origindate = Date.parse(time1);
                let date = new Date(origindate + 8 * 60 * 60 * 1000)
                let Y = date.getFullYear() + '-';
                let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                let D = date.getDate() + ' ';
                let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
                let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
                return Y + M + D + h + m + s
                // return date;
            }
        },
        watch: {
            pager: {
                deep: true,
                handler: function () {
                    this.$_getTableList();
                },
            },
        }
    }
</script>

<style lang="less" scoped>
    .warning-list {
        .mc-search-bar {
            // width: 100%;
            height: 100%;
            display: flex;

            .mc-search-bar-input {
                margin-right: 10px;
                display: inline-flex;
            }

            .mc-search-bar-btn {
                height: 40px;
            }
        }

        .deal-item {
            cursor: pointer;
            color: #1890FF;
        }

        .content {
            min-width: 400px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .site-content {
            display: inline-flex;
            width: 100%;
            margin-bottom: 10px;

            .site-content-item {
                flex: 1
            }
        }
    }
</style>